// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"805":"25f4ac2a","851":"da5c6245"}[chunkId] || chunkId) + "." + {"1":"fd5b97c30e5706a0","727":"30d4d8091aa4943c","762":"a4511841f1bd16b8","805":"82ac8ecc1571bb1f","851":"934bd124abc4f98c"}[chunkId] + ".js";
};